import React from "react";
import styles from "./KPITile.module.scss";
import Skeleton from "../Skeleton/Skeleton";

interface KPITileProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  dataTestId?: string;
  loading?: boolean;
}

const KPITile: React.FC<KPITileProps> = ({
  title,
  children,
  className = "",
  dataTestId = "kpi-tile",
  loading = false,
}) => {
  if (loading) {
    return <Skeleton className={`${className}`} height={'200px'} />;
  }

  return (
    <div
      className={`${styles.kpi_tile} ${className}`}
      data-testid={dataTestId}
    >
      <div className={styles.kpi_tile_header} data-testid={`${dataTestId}-header`}>
        {title}
      </div>
      <div className={styles.kpi_tile_content} data-testid={`${dataTestId}-content`}>
        {children}
      </div>
    </div>
  );
};

export default KPITile;
